import React from 'react';
import { Link } from 'react-router-dom';
import css from './MembershipBanner.module.css';

/**
 * Ottawa–Rideau Lakes Summer Membership promo banner.
 *
 * Shared between the LandingPage (top of home) and corridor city pages
 * (Ottawa, Brockville, Kingston). Same visual treatment everywhere so the
 * offer reads as a single coherent program across the site.
 *
 * The banner is geo-scoped via copy, not via render conditions — anyone
 * landing on a non-corridor city page already won't see it because those
 * pages don't pass `showMembershipBanner`. The home page intentionally
 * shows it to everyone, with the regional scope explicit in the headline.
 */
const MembershipBanner = () => (
  <section className={css.banner} aria-labelledby="membership-banner-title">
    <div className={css.inner}>
      <div className={css.text}>
        <p className={css.eyebrow}>NEW · Only 5 memberships this year</p>
        <h2 id="membership-banner-title" className={css.title}>
          Rent boats for $1 all summer.
        </h2>
        <p className={css.copy}>
          The Ottawa–Rideau Lakes Summer Membership: pay once, get 12 days
          of $1-per-booking rentals on participating Seadoos and boats. Or grab a
          Last-Minute spot for 8 days of within-48-hour bookings.
        </p>
        <p className={css.installments}>
          Installments available — from <strong>$387/mo</strong> (Last-Minute) or{' '}
          <strong>$1,000/mo</strong> (Summer). <span className={css.installmentsTax}>+ HST</span>
        </p>
        <p className={css.initiation}>
          <span className={css.strike}>$249.99 initiation fee</span>{' '}
          <span className={css.waived}>WAIVED · first 5 members only</span>
        </p>
      </div>
      <div className={css.actions}>
        <Link to="/membership/join" className={css.cta}>
          Join from $1,549
        </Link>
        <span className={css.hint}>
          $3,999 + HST / season · all platform fees baked in · pay monthly
        </span>
      </div>
    </div>
  </section>
);

export default MembershipBanner;
